import * as React from "react";
import { cn } from "@/lib/utils";

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

function Textarea({
  className,
  ref,
  ...props
}: TextareaProps & { ref?: React.Ref<HTMLTextAreaElement> }) {
  return (
    <textarea
      className={cn(
        "flex min-h-[80px] w-full rounded-lg border border-input bg-background px-3 py-2 text-sm text-foreground",
        "placeholder:text-muted-foreground/50",
        "transition-colors resize-none",
        // O mesmo foco do ecrã de entrada: um halo suave, não um contorno
        // cheio da cor da marca (que aqui é laranja e saltava à vista).
        "focus-visible:border-primary focus-visible:outline-hidden focus-visible:ring-4 focus-visible:ring-primary/10",
        "disabled:cursor-not-allowed disabled:bg-muted/40 disabled:text-muted-foreground disabled:border-border/60",
        "read-only:bg-muted/30 read-only:text-muted-foreground",
        className
      )}
      ref={ref}
      {...props}
    />
  );
}

export { Textarea };
